import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import {
//   Button,
//   Select,
//   Option,
//   Input,
//   Message,
//   Image,
//   Loading,
// } from "element-ui";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { loading } from "@u/index";
import "./icons"; // icon
import "../static/font/font.css";
import { handleTree } from "@/utils/ruoyi";
import VueSuperSlide from 'vue-superslide'

Vue.use(VueSuperSlide)
Vue.use(ElementUI);
Vue.config.productionTip = false;
// Vue.component(Button.name, Button);
// Vue.component(Select.name, Select);
// Vue.component(Option.name, Option);
// Vue.component(Input.name, Input);
// Vue.component(Image.name, Image);
// Vue.use(Loading);

// Vue.prototype.$message = Message;
Vue.prototype.$bus = new Vue()

Vue.prototype.$loading = loading;
Vue.prototype.handleTree = handleTree;
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面 title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path == "/home") {
    store.commit("SET_MENUID", "0");
  } else if (to.meta.level == 2 && to.query.id) {
    store.commit("SET_MENUID", to.query.id);
    // 从列表页到详情时将列表页缓存
    store.commit("SET_INCLUDEARR", [to.name]);
  }
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    router.addRoutes([]);
  },
}).$mount("#app");
